import { QueryClient } from '@tanstack/react-query';

/**
 * Create a query client for the `react-query`'s QueryClientProvider
 *
 * See: https://tanstack.com/query/latest/docs/reference/QueryClient
 */
export const queryClient = new QueryClient();
